export function buildWizardInstallCommand(apiKey: string, bindingId: string): string {
  const quote = (v: string) => `"${v.replace(/"/g, '\\"')}"`;
  return `npx @memaraio/wizard --project --yes --api-key ${quote(apiKey)} --binding-id ${quote(bindingId)}`;
}
